import { defaultUnits, QuantitiesTypes } from 'common/enums/unit-templates.js';
import { KnowTableData } from './table-enums.js';

const covarianceMatrixTotalMap = new Map();

covarianceMatrixTotalMap.set(KnowTableData.DepthMD, {
  key: KnowTableData.DepthMD,
  unit: defaultUnits.get(QuantitiesTypes.Depth),
  quantity: QuantitiesTypes.Depth,
  label: 'Depth MD',
});

covarianceMatrixTotalMap.set(KnowTableData.Inclination, {
  key: KnowTableData.Inclination,
  unit: defaultUnits.get(QuantitiesTypes.Angle),
  quantity: QuantitiesTypes.Angle,
  label: 'Inclination',
});

covarianceMatrixTotalMap.set(KnowTableData.Azimuth, {
  key: KnowTableData.Azimuth,
  unit: defaultUnits.get(QuantitiesTypes.Angle),
  quantity: QuantitiesTypes.Angle,
  label: 'Azimuth',
});

covarianceMatrixTotalMap.set(KnowTableData.DepthTVD, {
  key: KnowTableData.DepthTVD,
  unit: defaultUnits.get(QuantitiesTypes.Depth),
  quantity: QuantitiesTypes.Depth,
  label: 'Depth TVD',
});

covarianceMatrixTotalMap.set(KnowTableData.NevNN, {
  key: KnowTableData.NevNN,
  unit: defaultUnits.get(QuantitiesTypes.Length),
  quantity: QuantitiesTypes.Length,
  label: 'NEV NN',
});

covarianceMatrixTotalMap.set(KnowTableData.NevNE, {
  key: KnowTableData.NevNE,
  unit: defaultUnits.get(QuantitiesTypes.Length),
  quantity: QuantitiesTypes.Length,
  label: 'NEV NE',
});

covarianceMatrixTotalMap.set(KnowTableData.NevNV, {
  key: KnowTableData.NevNV,
  unit: defaultUnits.get(QuantitiesTypes.Length),
  quantity: QuantitiesTypes.Length,
  label: 'NEV NV',
});

covarianceMatrixTotalMap.set(KnowTableData.NevEE, {
  key: KnowTableData.NevEE,
  unit: defaultUnits.get(QuantitiesTypes.Length),
  quantity: QuantitiesTypes.Length,
  label: 'NEV EE',
});

covarianceMatrixTotalMap.set(KnowTableData.NevEV, {
  key: KnowTableData.NevEV,
  unit: defaultUnits.get(QuantitiesTypes.Length),
  quantity: QuantitiesTypes.Length,
  label: 'NEV EV',
});

covarianceMatrixTotalMap.set(KnowTableData.NevVV, {
  key: KnowTableData.NevVV,
  unit: defaultUnits.get(QuantitiesTypes.Length),
  quantity: QuantitiesTypes.Length,
  label: 'NEV VV',
});

export {
  covarianceMatrixTotalMap,
};
